import { CustomButtonProps, TextSize, Weight } from 'components'
import styled, { css } from 'styled-components'

import { GLOBAL_COLORS } from 'theme/global-theme'

export const Base = styled.button<Omit<CustomButtonProps, 'text'>>`
  border: none;
  cursor: pointer;
  transition: 0.4s all;

  &:active {
    opacity: 0.5;
  }
`

export const StyledButton = styled(Base)<{
  text: string
  isDarkTheme?: boolean
  isActive?: boolean
}>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  line-height: 20px;
  ${({ text }) => (text ? 'padding: 0 28px;' : 'padding: 0px;')}
  transition: 0.4s all;
  border-radius: 20px;
  &:disabled {
    background-color: ${GLOBAL_COLORS.coreGrey};
    color: ${GLOBAL_COLORS.seashellWhite};
    border: 1px solid ${GLOBAL_COLORS.coreGrey};
    cursor: not-allowed;
    &:hover {
      background-color: ${GLOBAL_COLORS.coreGrey};
      color: ${GLOBAL_COLORS.seashellWhite};
      border: 1px solid ${GLOBAL_COLORS.coreGrey};
    }
    &:active {
      opacity: 1;
    }
  }
  ${(props) => {
    switch (props.buttonType) {
      case 'primary':
        return css`
          background-color: ${GLOBAL_COLORS.ultramarine};
          color: ${GLOBAL_COLORS.white};
          border: 1px solid ${GLOBAL_COLORS.ultramarine};
          font-weight: ${Weight.Medium};
          &:hover {
            background-color: ${GLOBAL_COLORS.darkUltramarine};
            border: 1px solid ${GLOBAL_COLORS.darkUltramarine};
            color: ${GLOBAL_COLORS.white};
            div {
              div {
                div {
                  svg {
                    stroke: ${props.isDarkTheme && props.isActive
                      ? GLOBAL_COLORS.white
                      : props.isActive
                        ? GLOBAL_COLORS.white
                        : props.theme.bg};
                    circle {
                      stroke: ${props.isDarkTheme && props.isActive
                        ? GLOBAL_COLORS.white
                        : props.isActive
                          ? GLOBAL_COLORS.white
                          : props.theme.bg};
                    }
                    text {
                      fill: ${props.isDarkTheme && props.isActive
                        ? GLOBAL_COLORS.white
                        : props.isActive
                          ? GLOBAL_COLORS.white
                          : props.theme.bg};
                    }
                  }
                }
              }
            }
          }
        `
      case 'secondary':
        return css`
          font-weight: ${Weight.Medium};
          background-color: ${GLOBAL_COLORS.transparent};
          color: ${props.theme.secondaryButtonText};
          border: 1px solid ${props.theme.secondaryButtonText};
          &:hover {
            background-color: ${props.theme.inverseBg};
            border: 1px solid ${props.theme.secondaryButtonText};
            color: ${props.theme.bg};
          }
        `
      case 'light-secondary':
        return css`
          font-weight: ${Weight.Medium};
          background-color: ${GLOBAL_COLORS.transparent};
          color: ${props.theme.whiteToCoreGrey};
          border: 1px solid ${GLOBAL_COLORS.secondGrey05};
          &:hover {
            background-color: ${props.theme.inverseBg};
            border: 1px solid ${props.theme.secondaryButtonText};
            color: ${props.theme.bg};
            div {
              div {
                div {
                  svg {
                    stroke: ${props.isDarkTheme && props.isActive
                      ? GLOBAL_COLORS.white
                      : props.isActive
                        ? GLOBAL_COLORS.white
                        : props.theme.bg};
                    circle {
                      stroke: ${props.isDarkTheme && props.isActive
                        ? GLOBAL_COLORS.white
                        : props.isActive
                          ? GLOBAL_COLORS.white
                          : props.theme.bg};
                    }
                    text {
                      fill: ${props.isDarkTheme && props.isActive
                        ? GLOBAL_COLORS.white
                        : props.isActive
                          ? GLOBAL_COLORS.white
                          : props.theme.bg};
                    }
                  }
                }
              }
            }
          }
        `
      case 'wallet':
        return css`
          font-weight: ${Weight.Medium};
          font-size: ${TextSize.four};
          &:hover {
            background-color: ${GLOBAL_COLORS.walletButton}33;
          }
          &:active {
            background-color: ${GLOBAL_COLORS.walletButton}33;
            opacity: 0.7;
          }
        `
      case 'warning':
        return css`
          font-weight: ${Weight.Medium};
          background-color: ${GLOBAL_COLORS.deepOceanBlue};
          color: ${GLOBAL_COLORS.seashellWhite};
          border: 1px solid ${GLOBAL_COLORS.deepOceanBlue};
          &:hover {
            div {
              div {
                div {
                  svg {
                    stroke: ${props.isDarkTheme && props.isActive
                      ? GLOBAL_COLORS.seashellWhite
                      : props.isActive
                        ? GLOBAL_COLORS.seashellWhite
                        : props.theme.bg};
                    circle {
                      stroke: ${props.isDarkTheme && props.isActive
                        ? GLOBAL_COLORS.seashellWhite
                        : props.isActive
                          ? GLOBAL_COLORS.seashellWhite
                          : props.theme.bg};
                    }
                    text {
                      fill: ${props.isDarkTheme && props.isActive
                        ? GLOBAL_COLORS.seashellWhite
                        : props.isActive
                          ? GLOBAL_COLORS.seashellWhite
                          : props.theme.bg};
                    }
                  }
                }
              }
            }
          }
        `
    }
  }}
`
